module.exports = __webpack_public_path__ + "h5/img/tixianx.d1e3ad27.jpg";